import { Component, Inject } from '@angular/core'
import { APP_CONFIG } from 'src/app/app.config'
import { AppConfigModel } from '../../models'
import { Permissions } from '../../enums/permissions.enum'

@Component({
  selector: 'app-app-selection',
  templateUrl: './app-selection.component.html',
  styleUrls: ['./app-selection.component.scss'],
  standalone: false,
})
export class AppSelectionComponent {
  Permissions = Permissions
  isContentVisible: boolean = false

  constructor(@Inject(APP_CONFIG) public readonly config: AppConfigModel) {}

  toggleContent() {
    this.isContentVisible = !this.isContentVisible
  }

  hideContent() {
    this.isContentVisible = false
  }
}
